export default __webpack_public_path__ + "static/media/シェリー.edfefd78.PNG";